import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import useStateHandler from '@/hooks/useStateHandler';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import OrderCard from '@/shared-components/cards/components/OrderCard';
import OrderShippingCard from '@/shared-components/cards/components/OrderShippingCard';
import GalleryCoolerIcon from '@/shared-components/icons/components/new-icons/GalleryCoolerIcon';

import './styles/OrderInfo.css';

export default function OrderInfo({ fetchData, setOpenIssueDetails, onAddShippingAddress }) {
  const { state } = useStateHandler();
  const currentUserId = state?.user_session?._id ?? null;
  const orderBuyerId = fetchData?.order_buyer?._id ?? fetchData?.order_buyer ?? null;
  const isBuyer = Boolean(
    currentUserId &&
    orderBuyerId &&
    String(currentUserId) === String(orderBuyerId)
  );
  const paymentStatus = fetchData?.status ?? null;
  const orderType = fetchData?.type ?? null;
  const orderStatus = fetchData?.order_shipping_address?.shipping_status
    ?? fetchData?.order_status
    ?? paymentStatus
    ?? null;
  const hasShippingAddress = Boolean(
    fetchData?.order_shipping_address?.address_name &&
    fetchData?.order_shipping_address?.address_street &&
    fetchData?.order_shipping_address?.address_country
  );
  const canPromptShipping =
    typeof onAddShippingAddress === "function" &&
    isBuyer &&
    !hasShippingAddress &&
    (
      orderStatus === "payment_pending" ||
      (paymentStatus === "paid" && orderType === "auction")
    );
  const shouldShowLimitedEditionStatusIcon = Boolean(
    fetchData?.order_limited_edition_data && !isBuyer
  );
  const artworkImageId = fetchData?.order_artwork?.artwork_media?.artwork_main_picture?.image_id ?? null;
  const hasArtworkImage = typeof artworkImageId === "string" && artworkImageId.length > 0;

  return (
    <>
      <div className="order-info__header">
        {orderStatus === "cancelled" ? (
          <span className="order-info__text canceled dots-on-overflow">
            Order canceled
          </span>
        ) : fetchData.order_issue ? (
          <span
            className="order-info__text theme dots-on-overflow element-non-selectable"
            onClick={() => setOpenIssueDetails(true)}
          >
            An issue has been reported
          </span>
        ) : isBuyer ? (
          fetchData.order_limited_edition_data ? (
            <>
              <LimitedEditionIcon className="order-info__icon"/>
              <span className="order-info__text dots-on-overflow">
                Suarte
              </span>
            </>
          ) : (
            <>
              <GalleryCoolerIcon className="order-info__icon"/>
              <span className="order-info__text dots-on-overflow">
                {fetchData.order_seller.user_name}
              </span>
            </>
          )
        ) : orderStatus === "payment_pending" ? (
          <>
            {shouldShowLimitedEditionStatusIcon && (
              <LimitedEditionIcon className="order-info__icon"/>
            )}
            <span className="order-info__text dots-on-overflow">
              Payment in progress
            </span>
          </>
        ) : (
          <>
            {shouldShowLimitedEditionStatusIcon && (
              <LimitedEditionIcon className="order-info__icon"/>
            )}
            <span className="order-info__text dots-on-overflow">
              {orderStatus === "pending"
                ? "Confirmed"
                : orderStatus === "sent"
                  ? "On its way"
                  : "Completed"}
            </span>
          </>
        )}
      </div>

      {hasArtworkImage ? (
        <ArtworkImage
          image={artworkImageId}
          imageClassName="order-info__artwork-image"
          imageTemplateClassName="order-info__artwork-image"
          forceSmaller={300}
        />
      ) : (
        <div
          className="order-info__artwork-image order-info__artwork-image--unavailable"
          aria-label="Artwork image unavailable"
          role="img"
        />
      )}

      <div className="order-info__order-card">
        <OrderCard
          orderData={fetchData}
          onSeeIssue={() => setOpenIssueDetails(true)}
          showShippingReminder={false}
          showArtworkImage={false}
          variant="detail"
        />
      </div>

      <OrderShippingCard
        shippingData={fetchData.order_shipping_address}
        onAddAddress={canPromptShipping ? onAddShippingAddress : null}
      />
    </>
  );
}
